import { render, staticRenderFns } from "./EventHeader.vue?vue&type=template&id=7506c8af"
import script from "./EventHeader.vue?vue&type=script&lang=js"
export * from "./EventHeader.vue?vue&type=script&lang=js"
import style0 from "./EventHeader.vue?vue&type=style&index=0&id=7506c8af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports